export default "__VITE_ASSET__DLxOBhKO__"